import { Fragment, ReactElement } from 'react';
import { Container, styled } from '@mui/material';
import { IDeaRegistration, ValueLabel, variables } from '../common';
import { show } from '.';
import { map as lmap, compose as lcompose } from 'lodash/fp';
import { left, right, fold } from 'fp-ts/lib/Either';

export const render = (properties: ValueLabel<keyof IDeaRegistration>[]) =>
  lcompose(
    fold(
      () => <Container maxWidth="xl">Empty</Container>,

      deaRegistrations => (
        <Container maxWidth="xl">
          <Article>
            {lmap<ValueLabel<string>, ReactElement>(({ label }) => (
              <h4 key={label}>{label}</h4>
            ))(properties)}

            {lcompose(
              lmap<IDeaRegistration, ReactElement>(a => (
                <Fragment key={a.deaNum}>
                  {lmap<ValueLabel<keyof IDeaRegistration>, ReactElement>(
                    ({ value }) => <span key={value}>{show(value)(a)}</span>
                  )(properties)}
                </Fragment>
              ))
            )(deaRegistrations)}
          </Article>
        </Container>
      )
    ),

    (deaRegistrations: IDeaRegistration[]) =>
      deaRegistrations.length === 0
        ? left(deaRegistrations)
        : right(deaRegistrations)
  );

const Article = styled('article')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',

  '&>*+*': {
    marginTop: '1rem',
  },

  '@media (min-width: 60em)': {
    display: 'grid',
    gridTemplateColumns: 'auto auto 1fr auto auto auto 1fr repeat(3,auto)',
    gap: '1px',

    backgroundColor: variables.grayLighter,
    border: variables.cardBorder,
    borderRadius: variables.cardBorderRadius,

    '&>*': {
      backgroundColor: '#fff',
      padding: '1rem',
    },

    '&>*+*': {
      marginTop: '0rem',
    },
  },
}));
